export default "__VITE_ASSET__BJn_nUAb__"